export default __webpack_public_path__ + "static/media/Marthina Ras.51d9f760.jpeg";